export default function Leadership() {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-slate-900 mb-16 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
            Leadership
          </h2>

          {/* Alberto Rocha - Director */}
          <div className="grid lg:grid-cols-3 gap-12 items-start mb-24">
            {/* Profile Image */}
            <div className="lg:col-span-1">
              <div className="bg-slate-100 aspect-[3/4] overflow-hidden shadow-xl">
                <img 
                  src="https://static.readdy.ai/image/d284d72deac738ef2474c9b45b1f2d97/7c12457f0c3ed53f27ff6ce928c65419.png"
                  alt="Alberto Rocha, Director"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Bio Content */}
            <div className="lg:col-span-2 space-y-6">
              <div>
                <h3 className="font-serif text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Alberto Rocha
                </h3>
                <p className="text-xl text-red-800 font-semibold mb-6">Director</p>
              </div>

              <div className="space-y-4 text-lg text-slate-700 leading-relaxed">
                <p>
                  Researcher and author of <strong>"The Mirror Effect: How AI's Consistency Exposes the Flaw in Human Moral Preference."</strong>
                </p>

                <p>
                  The author of <strong>19 books on AI</strong> and host of the <strong>200-episode podcast "AI and Us: Exploring Our Future,"</strong> Rocha's forthcoming book <strong>"AI is More Human than Humans: A Mirror to Our Better Angels"</strong> offers the first practitioner's guide to implementing NIST AI RMF Executive Order mandates of <em>Promoting the Use of Trustworthy Artificial Intelligence in the Federal Government</em>, <em>Safe, Secure, and Trustworthy Development and Use of Artificial Intelligence</em>, <em>Winning the Race: America's AI Action Plan</em>, through <strong>Consistency Auditing</strong>—a methodology that makes ethical AI governance actionable for the 430+ federal agencies required to comply.
                </p>

                <p>
                  A <strong>Congressional appointee</strong>, professional speaker with <strong>40 years of experience</strong>, and passionate advocate for algorithmic accountability, Rocha connects the civil rights movement's lessons to today's AI challenges.
                </p>
              </div>

              <div className="flex flex-wrap gap-3 pt-4">
                <span className="bg-slate-900 text-white px-4 py-2 text-sm font-semibold whitespace-nowrap">Congressional Appointee</span>
                <span className="bg-red-800 text-white px-4 py-2 text-sm font-semibold whitespace-nowrap">19 Books Published</span>
                <span className="bg-slate-900 text-white px-4 py-2 text-sm font-semibold whitespace-nowrap">200-Episode Podcast</span>
                <span className="bg-red-800 text-white px-4 py-2 text-sm font-semibold whitespace-nowrap">40 Years Experience</span>
              </div>
            </div>
          </div>

          {/* Angel Luevano - Co-Founder */}
          <div className="grid lg:grid-cols-3 gap-12 items-start">
            {/* Profile Image */}
            <div className="lg:col-span-1">
              <div className="bg-slate-100 aspect-[3/4] overflow-hidden shadow-xl">
                <img 
                  src="https://static.readdy.ai/image/d284d72deac738ef2474c9b45b1f2d97/0afe749ede11222024e10015056516f2.png"
                  alt="Angel Luevano, Co-Founder"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Bio Content */}
            <div className="lg:col-span-2 space-y-6">
              <div>
                <h3 className="font-serif text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Angel Luevano
                </h3>
                <p className="text-xl text-red-800 font-semibold mb-6">Co-Founder</p>
              </div>

              <div className="space-y-4 text-lg text-slate-700 leading-relaxed">
                <p>
                  Angel Luevano is a civil rights figure whose legacy is anchored in his role as the lead plaintiff in <strong>Luevano v. Campbell</strong>—the landmark class-action that successfully challenged the federal government's "Professional and Administrative Career Examination" (PACE) for its discriminatory impact on minority applicants. The resulting <strong>1981 Luevano Consent Decree</strong> eliminated the PACE exam and created equitable hiring pathways, fundamentally reforming federal employment for decades.
                </p>

                <p>
                  Mr. Luevano served a distinguished <strong>30-year career</strong> within the very system he helped reform, holding high-ranking federal positions where he drafted regulations on detecting employment discrimination. He now co-leads the <strong>Algorithmic Consistency Initiative (ACI)</strong>, ensuring the legal principle established in his decree—that selection systems must be provably fair—is engineered into the algorithmic tools of the 21st century.
                </p>

                <p>
                  A graduate of <strong>UC Law San Francisco</strong>, he is authoring a memoir on his historic case and resides in Sacramento.
                </p>
              </div>

              <div className="flex flex-wrap gap-3 pt-4">
                <span className="bg-slate-900 text-white px-4 py-2 text-sm font-semibold whitespace-nowrap">Civil Rights Pioneer</span>
                <span className="bg-red-800 text-white px-4 py-2 text-sm font-semibold whitespace-nowrap">Luevano v. Campbell</span>
                <span className="bg-slate-900 text-white px-4 py-2 text-sm font-semibold whitespace-nowrap">30 Years Federal Service</span>
                <span className="bg-red-800 text-white px-4 py-2 text-sm font-semibold whitespace-nowrap">UC Law San Francisco</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
